import { render, staticRenderFns } from "./index.vue?vue&type=template&id=976c6a0c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,Includes: require('/usr/src/app/components/plus/includes.vue').default,Form: require('/usr/src/app/components/plus/form.vue').default,Dashboard: require('/usr/src/app/components/plus/dashboard.vue').default,BottomSection: require('/usr/src/app/components/plus/bottom-section.vue').default,FooterCta: require('/usr/src/app/components/common-sections/footer-cta.vue').default})
